import { binderInstitutionIdSelector } from 'common/selectors';
import { queryGraphQL, mutateGraphQL } from 'complionUtil/query';

import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { toMutation, toQuery, nodeWithArgs, node } from 'complionUtil/queryHelper';

export const LOAD_STUDY_SIGNATURE_EXPECTATIONS_V2 = 'LOAD_STUDY_SIGNATURE_EXPECTATIONS_V2';
export const LOAD_STUDY_SIGNATURES_V2 = 'LOAD_STUDY_SIGNATURES_V2';
export const SATISFY_SIGNATURE_EXPECTATIONS_V2 = 'SATISFY_SIGNATURE_EXPECTATIONS_V2';

export function loadSignatureExpectationsV2(binderId, studyId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs(
            'doaSignatureExpectationsV2',
            {
                binderId,
                institutionId,
                studyId,
            },
            [
                'delegationId',
                'signatureType',
                'testament',
                node('user', ['id', 'displayName', 'emailAddress']),
                'signedAt',
                'signatureStatus',
                'updatedAt',
                'signBy'
            ]
        );

        return queryGraphQL(toQuery(query)).then((results) => {
            if (results && results.errors) {
                dispatch(
                    addApplicationMessage('error', 'Failed to retrieve signature expectations')
                );
            } else {
                dispatch({
                    type: LOAD_STUDY_SIGNATURE_EXPECTATIONS_V2,
                    payload: results.data.doaSignatureExpectationsV2,
                });
            }
        });
    };
}

export function loadStudySignaturesV2(binderId, studyId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        dispatch({
            type: 'LOADING_STUDY_SIGNATURES_V2',
            payload: null,
        });
        const query = nodeWithArgs(
            'studySignaturesV2',
            {
                binderId,
                institutionId,
                studyId,
            },
            [
                'id',
                'delegationId',
                'signatureType',
                'signatureStatus',
                'signBy',
                node('signature', [
                    'id',
                    node('user', ['id', 'displayName', 'emailAddress']),
                    'statement',
                    'createdAt',
                ]),
            ]
        );

        return queryGraphQL(toQuery(query)).then((results) => {
            if (results && results.errors) {
                dispatch(
                    addApplicationMessage(
                        'error',
                        'Failed to retrieve signatures for delegation log'
                    )
                );
            } else {
                dispatch({
                    type: LOAD_STUDY_SIGNATURES_V2,
                    payload: results.data.studySignaturesV2,
                });
            }
        });
    };
}

export function satisfySignatureExpectationsV2(binderId, studyId, userId, signature, signatureExpectations) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs(
            'satisfySignatureExpectationsV2',
            {
                institutionId,
                binderId,
                studyId,
                userId,
                signature,
                signatureExpectations,
            },
            [
                'id',
                'delegationId',
                'signatureType',
                node('signature', [
                    'userId',
                    node('user', [
                        // needed here to allow the user to export without refreshing first
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    'statement',
                    'createdAt',
                ]),
            ]
        );
        return mutateGraphQL(toMutation(query)).then((results) => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to sign delegations'));
            } else {
                dispatch({
                    type: SATISFY_SIGNATURE_EXPECTATIONS_V2,
                    payload: results.data.satisfySignatureExpectationsV2,
                });
                dispatch(loadSignatureExpectationsV2(binderId), studyId);
                dispatch(loadStudySignaturesV2(binderId, studyId));
                dispatch(addApplicationMessage('success', 'Successfully signed delegations'));
            }
        });
    };
}
